import apiClient from './apiClient';

const API_URL = '/tramites/minusvalia';

// Listar / filtrar trámites de Minusvalía
export const getTramitesMinusvalia = async (idCliente = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Detalle de un trámite
export const getTramiteMinusvaliaById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear un nuevo trámite de Minusvalía
export const crearTramiteMinusvalia = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite de Minusvalía:', error.response?.data || error.message);
        throw error;
    }
};

// Editar datos del trámite (no el cliente)
export const actualizarTramiteMinusvalia = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

// Actualizar observaciones/comentarios (nota editable con firma)
export const actualizarComentariosMinusvalia = async (id, comentarios) => {
    const response = await apiClient.patch(`${API_URL}/${id}/comentarios`, { comentarios });
    return response.data;
};

// Avanzar de estado: cada transición manda su propio mini-formulario (destino + dato de la etapa)
export const avanzarEstadoMinusvalia = async (id, dto) => {
    const response = await apiClient.patch(`${API_URL}/${id}/estado`, dto);
    return response.data;
};

// Regularidad de aportes para minusvalía (240 meses totales, 120 consecutivos antes del cese),
// calculada en vivo a partir de los aportes ya cargados del cliente.
export const getRegularidadMinusvalia = async (cuil) => {
    const response = await apiClient.get(`${API_URL}/regularidad-cliente/${cuil}`);
    return response.data;
};

const minusvaliaService = {
    getTramitesMinusvalia,
    getTramiteMinusvaliaById,
    crearTramiteMinusvalia,
    actualizarTramiteMinusvalia,
    actualizarComentariosMinusvalia,
    avanzarEstadoMinusvalia,
    getRegularidadMinusvalia,
};

export default minusvaliaService;
